export default {
  assistanceQueryDetail: {
    title: "",
    component: () =>
      import("@/mods/archive/assistanceQuery/detailView/AssistanceQueryDetail"),
  },
};
